(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands_slider"] && !Shopify.designMode) return;
  try {
    

// form a brands slider with slick
  $('.brands-responsive').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 4,
 	arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-child-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // CSS handles hiding things instantly, JS just toggles the ".is-expanded" class.
    
    // UPDATED LOGIC: Now checks for size, width, and brand parameters
    function isSizeParamKey(key) {
      if (!key) return false;

      var normalized = String(key).toLowerCase();
      
      // Exclusions
      if (normalized === 'page_size') return false;
      if (normalized.indexOf('resize') !== -1) return false;

      // Inclusions: Persist size, width, and brand filters
      if (normalized.indexOf('size') !== -1) return true;
      if (normalized.indexOf('width') !== -1) return true;
      if (normalized.indexOf('brand') !== -1) return true;

      return false;
    }

    function getCurrentSizeParams() {
      var currentSizeParams = [];
      if (!window.URLSearchParams || !window.location) return currentSizeParams;

      function pushUniqueParam(key, value) {
        for (var i = 0; i < currentSizeParams.length; i += 1) {
          if (currentSizeParams[i].key === key && currentSizeParams[i].value === value) {
            return;
          }
        }

        currentSizeParams.push({ key: key, value: value });
      }

      var currentParams = new URLSearchParams(window.location.search || '');
      currentParams.forEach(function (value, key) {
        if (isSizeParamKey(key)) {
          pushUniqueParam(key, value);
        }
      });

      var filterInputs = document.querySelectorAll('input[name], select[name]');
      for (var inputIndex = 0; inputIndex < filterInputs.length; inputIndex += 1) {
        var input = filterInputs[inputIndex];
        if (!input) continue;

        var inputName = input.name || '';
        if (!isSizeParamKey(inputName)) continue;

        var tagName = (input.tagName || '').toLowerCase();
        if (tagName === 'input') {
          var type = (input.type || '').toLowerCase();
          if (type !== 'checkbox' && type !== 'radio') continue;
          if (!input.checked) continue;
          pushUniqueParam(inputName, input.value);
          continue;
        }

        if (tagName === 'select') {
          if (input.multiple && input.options) {
            for (var optionIndex = 0; optionIndex < input.options.length; optionIndex += 1) {
              var option = input.options[optionIndex];
              if (option && option.selected && option.value !== '') {
                pushUniqueParam(inputName, option.value);
              }
            }
          } else {
            if (input.value !== '') {
              pushUniqueParam(inputName, input.value);
            }
          }
        }
      }

      return currentSizeParams;
    }

    function removeSizeParamsFromUrl(linkUrl) {
      var keysToDelete = [];
      linkUrl.searchParams.forEach(function (_, key) {
        if (isSizeParamKey(key) && keysToDelete.indexOf(key) === -1) {
          keysToDelete.push(key);
        }
      });

      for (var keyIndex = 0; keyIndex < keysToDelete.length; keyIndex += 1) {
        linkUrl.searchParams.delete(keysToDelete[keyIndex]);
      }
    }

    function toRelativeHref(urlObject) {
      return urlObject.pathname + urlObject.search + urlObject.hash;
    }

    function initializeChildLinkBaseHref(link) {
      if (!link) return;
      if (link.getAttribute('data-child-grid-base-href')) return;

      var href = link.getAttribute('href');
      if (!href) return;
      if (href.indexOf('javascript:') === 0 || href.charAt(0) === '#') return;

      var linkUrl;
      try {
        linkUrl = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      removeSizeParamsFromUrl(linkUrl);
      link.setAttribute('data-child-grid-base-href', toRelativeHref(linkUrl));
    }

    function applyCurrentSizeParamsToLink(link) {
      if (!link) return;

      var baseHref = link.getAttribute('data-child-grid-base-href');
      var href = baseHref || link.getAttribute('href');
      if (!href) return;
      if (href.indexOf('javascript:') === 0 || href.charAt(0) === '#') return;

      var linkUrl;
      try {
        linkUrl = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      removeSizeParamsFromUrl(linkUrl);

      var currentSizeParams = getCurrentSizeParams();
      for (var sizeIndex = 0; sizeIndex < currentSizeParams.length; sizeIndex += 1) {
        linkUrl.searchParams.append(currentSizeParams[sizeIndex].key, currentSizeParams[sizeIndex].value);
      }

      link.setAttribute('href', toRelativeHref(linkUrl));
    }

    function persistSizesParamsOnChildLinks(section) {
      if (!section) return;
      if (!window.URLSearchParams || !window.URL) return;

      var links = section.querySelectorAll('[data-child-grid-card]');
      for (var linkIndex = 0; linkIndex < links.length; linkIndex += 1) {
        var link = links[linkIndex];
        initializeChildLinkBaseHref(link);
        applyCurrentSizeParamsToLink(link);

        if (link.getAttribute('data-child-grid-size-listener') !== 'true') {
          link.addEventListener('click', function (event) {
            applyCurrentSizeParamsToLink(event.currentTarget);
          });
          link.setAttribute('data-child-grid-size-listener', 'true');
        }
      }
    }

    function syncCollectionChildGridLinks(root) {
      var context = root || document;
      var sections = context.querySelectorAll('[data-child-grid-section]');

      for (var sectionIndex = 0; sectionIndex < sections.length; sectionIndex += 1) {
        persistSizesParamsOnChildLinks(sections[sectionIndex]);
      }
    }

    function bindCollectionChildGridSizeSyncListeners() {
      if (window.__collectionChildGridSizeSyncBound) return;
      window.__collectionChildGridSizeSyncBound = true;

      function scheduleSync() {
        window.setTimeout(function () {
          syncCollectionChildGridLinks(document);
        }, 0);
      }

      function wrapHistoryMethod(methodName) {
        if (!window.history || typeof window.history[methodName] !== 'function') return;

        var originalMethod = window.history[methodName];
        if (originalMethod.__collectionChildGridWrapped) return;

        var wrappedMethod = function () {
          var result = originalMethod.apply(window.history, arguments);
          scheduleSync();
          return result;
        };

        wrappedMethod.__collectionChildGridWrapped = true;
        window.history[methodName] = wrappedMethod;
      }

      wrapHistoryMethod('pushState');
      wrapHistoryMethod('replaceState');

      window.addEventListener('popstate', scheduleSync);
      window.addEventListener('hashchange', scheduleSync);

      document.addEventListener(
        'change',
        function (event) {
          var target = event.target;
          if (!target) return;

          var targetName = target.name || '';
          var targetId = target.id || '';
          if (isSizeParamKey(targetName) || isSizeParamKey(targetId)) {
            scheduleSync();
            window.setTimeout(scheduleSync, 150);
          }
        },
        true
      );
    }

    function initChildGridSection(section) {
      if (!section || section.dataset.childGridReady == 'true') return;

      persistSizesParamsOnChildLinks(section);

      var cardsContainer = section.querySelector('[data-child-grid-cards]');
      var button = section.querySelector('[data-child-grid-load-more]');

      if (!cardsContainer || !button) {
        if (section) section.dataset.childGridReady = 'true';
        return;
      }

      var isExpanded = false;
      var showText = button.textContent.trim();
      var hideText = button.getAttribute('data-hide-text') || 'Hide';

      button.addEventListener('click', function () {
        isExpanded = !isExpanded;

        if (isExpanded) {
          cardsContainer.classList.add('is-expanded');
          button.textContent = hideText;
        } else {
          cardsContainer.classList.remove('is-expanded');
          button.textContent = showText;
          section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });

      section.dataset.childGridReady = 'true';
    }

    function initCollectionChildGrids(root) {
      var context = root || document;
      var sections = context.querySelectorAll('[data-child-grid-section]');

      for (var index = 0; index < sections.length; index += 1) {
        initChildGridSection(sections[index]);
      }

      syncCollectionChildGridLinks(context);
    }

    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCollectionChildGrids(document);
      });
    } else {
      initCollectionChildGrids(document);
    }

    if (!window.__collectionChildGridSectionLoadBound) {
      window.__collectionChildGridSectionLoadBound = true;
      document.addEventListener('shopify:section:load', function (event) {
        initCollectionChildGrids(event.target);
      });
    }

    bindCollectionChildGridSizeSyncListeners();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-relationship-tree"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ISSUE_FILTERS = [
      {
        key: 'missing-image',
        label: 'Image missing',
        tooltip: 'The collection has no collection image assigned.',
        codes: ['missing-image']
      },
      {
        key: 'missing-parent',
        label: 'Missing parent',
        tooltip: 'The collection points to a parent that does not exist or cannot be found.',
        codes: ['missing-parent']
      },
      {
        key: 'child-mismatch',
        label: 'Child mismatch',
        tooltip: 'The stored parent and child relationship fields disagree with each other.',
        codes: ['missing-child-reference', 'child-parent-mismatch', 'derived-child-missing-from-links', 'blank-parent-field']
      },
      {
        key: 'top-parent-mismatch',
        label: 'Top parent mismatch',
        tooltip: 'The stored top parent does not match the real top ancestor in the tree.',
        codes: ['top-parent-mismatch']
      },
      {
        key: 'cycle-detected',
        label: 'Cycle detected',
        tooltip: 'The parent chain loops back on itself instead of ending at a root.',
        codes: ['cycle-detected']
      }
    ];

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function parseConfig(container) {
      var configElement = container.querySelector('[data-collection-tree-config]');
      if (!configElement) return null;

      try {
        return JSON.parse(configElement.textContent);
      } catch (error) {
        return null;
      }
    }

    function normalizeString(value) {
      if (value === null || value === undefined) return '';
      return String(value).trim();
    }

    function uniqueNonBlank(values) {
      var normalized = [];
      var seen = {};

      if (!values || !values.length) return normalized;

      for (var index = 0; index < values.length; index += 1) {
        var value = normalizeString(values[index]);
        if (!value) continue;
        if (seen[value]) continue;
        seen[value] = true;
        normalized.push(value);
      }

      return normalized;
    }

    function normalizeCollection(rawCollection) {
      return {
        id: rawCollection && rawCollection.id ? String(rawCollection.id) : '',
        handle: normalizeString(rawCollection && rawCollection.handle),
        title: normalizeString(rawCollection && rawCollection.title),
        url: normalizeString(rawCollection && rawCollection.url),
        adminUrl: normalizeString(rawCollection && rawCollection.admin_url),
        imageUrl: normalizeString(rawCollection && rawCollection.image_url),
        imageAlt: normalizeString(rawCollection && rawCollection.image_alt),
        parentHandle: normalizeString(rawCollection && rawCollection.parent_handle),
        topParentHandle: normalizeString(rawCollection && rawCollection.top_parent_handle),
        childHandles: uniqueNonBlank(rawCollection && rawCollection.child_handles ? rawCollection.child_handles : []),
        isSmart: !!(rawCollection && rawCollection.is_smart)
      };
    }

    function compareHandles(model, leftHandle, rightHandle) {
      var leftNode = model.byHandle[leftHandle];
      var rightNode = model.byHandle[rightHandle];
      var leftTitle = leftNode ? leftNode.title : leftHandle;
      var rightTitle = rightNode ? rightNode.title : rightHandle;
      return leftTitle.localeCompare(rightTitle, undefined, { sensitivity: 'base' });
    }

    function pushIssue(node, code, label, detail) {
      if (!node || !code || !label) return;
      if (!node.issueCodes) node.issueCodes = {};
      if (node.issueCodes[code]) return;
      node.issueCodes[code] = true;
      node.issues.push({ code: code, label: label, detail: normalizeString(detail) });
    }

    function nodeMatchesIssueFilter(node, issueFilterKey) {
      if (!issueFilterKey) return true;
      if (!node || !node.issueCodes) return false;

      for (var filterIndex = 0; filterIndex < ISSUE_FILTERS.length; filterIndex += 1) {
        var filter = ISSUE_FILTERS[filterIndex];
        if (filter.key !== issueFilterKey) continue;
        for (var codeIndex = 0; codeIndex < filter.codes.length; codeIndex += 1) {
          if (node.issueCodes[filter.codes[codeIndex]]) return true;
        }
      }

      return false;
    }

    function getIssueFilterMeta(issueFilterKey) {
      for (var filterIndex = 0; filterIndex < ISSUE_FILTERS.length; filterIndex += 1) {
        if (ISSUE_FILTERS[filterIndex].key === issueFilterKey) return ISSUE_FILTERS[filterIndex];
      }
      return null;
    }

    function buildModel(collections) {
      var model = {
        byHandle: {},
        roots: [],
        relatedHandles: [],
        stats: {
          scannedCollections: 0,
          relatedCollections: 0,
          rootBranches: 0,
          missingImages: 0,
          issueNodes: 0,
          issueCounts: {}
        }
      };

      var referencedAsParent = {};
      var referencedInChildLinks = {};
      var referencedByChildLinks = {};
      var handles = [];
      var index;

      for (index = 0; index < collections.length; index += 1) {
        var normalizedCollection = normalizeCollection(collections[index]);
        if (!normalizedCollection.handle) continue;
        normalizedCollection.derivedChildren = [];
        normalizedCollection.issues = [];
        normalizedCollection.issueCodes = {};
        normalizedCollection.related = false;
        normalizedCollection.rootHandle = '';
        normalizedCollection.cycle = false;
        normalizedCollection.depth = 0;
        model.byHandle[normalizedCollection.handle] = normalizedCollection;
      }

      handles = Object.keys(model.byHandle);
      model.stats.scannedCollections = handles.length;

      for (index = 0; index < handles.length; index += 1) {
        var currentNode = model.byHandle[handles[index]];
        if (currentNode.parentHandle) referencedAsParent[currentNode.parentHandle] = true;
        for (var childIndex = 0; childIndex < currentNode.childHandles.length; childIndex += 1) {
          var referencedChildHandle = currentNode.childHandles[childIndex];
          referencedInChildLinks[referencedChildHandle] = true;
          if (!referencedByChildLinks[referencedChildHandle]) referencedByChildLinks[referencedChildHandle] = [];
          referencedByChildLinks[referencedChildHandle].push(currentNode.handle);
        }
      }

      for (index = 0; index < handles.length; index += 1) {
        currentNode = model.byHandle[handles[index]];
        currentNode.related = !!currentNode.parentHandle || currentNode.childHandles.length > 0 || !!referencedAsParent[currentNode.handle] || !!referencedInChildLinks[currentNode.handle];
      }

      for (index = 0; index < handles.length; index += 1) {
        currentNode = model.byHandle[handles[index]];
        if (!currentNode.parentHandle) continue;
        if (!model.byHandle[currentNode.parentHandle]) continue;
        model.byHandle[currentNode.parentHandle].derivedChildren.push(currentNode.handle);
      }

      for (index = 0; index < handles.length; index += 1) {
        currentNode = model.byHandle[handles[index]];
        currentNode.derivedChildren.sort(function (leftHandle, rightHandle) {
          return compareHandles(model, leftHandle, rightHandle);
        });
      }

      for (index = 0; index < handles.length; index += 1) {
        currentNode = model.byHandle[handles[index]];
        if (!currentNode.related) continue;

        model.relatedHandles.push(currentNode.handle);

        if (!currentNode.imageUrl) pushIssue(currentNode, 'missing-image', 'Image missing');
        if (currentNode.parentHandle && !model.byHandle[currentNode.parentHandle]) {
          pushIssue(currentNode, 'missing-parent', 'Missing parent', 'Expected parent: ' + describeHandle(model, currentNode.parentHandle));
        }
        if (!currentNode.parentHandle && referencedInChildLinks[currentNode.handle]) {
          var referencingParents = uniqueNonBlank(referencedByChildLinks[currentNode.handle] || []);
          pushIssue(
            currentNode,
            'blank-parent-field',
            'Parent field is blank',
            referencingParents.length ? 'Referenced from child links by: ' + referencingParents.map(function (handle) { return describeHandle(model, handle); }).join('; ') : ''
          );
        }

        var missingChildReferences = 0;
        var mismatchedChildLinks = 0;
        var missingChildReferenceDetails = [];
        var mismatchedChildLinkDetails = [];
        for (var auditChildIndex = 0; auditChildIndex < currentNode.childHandles.length; auditChildIndex += 1) {
          var childHandle = currentNode.childHandles[auditChildIndex];
          var childNode = model.byHandle[childHandle];
          if (!childNode) {
            missingChildReferences += 1;
            missingChildReferenceDetails.push(describeHandle(model, childHandle));
            continue;
          }
          if (childNode.parentHandle !== currentNode.handle) {
            mismatchedChildLinks += 1;
            var actualParentLabel = childNode.parentHandle ? describeHandle(model, childNode.parentHandle) : 'blank';
            mismatchedChildLinkDetails.push(describeHandle(model, childHandle) + ' -> parent field points to ' + actualParentLabel);
          }
        }

        if (missingChildReferences > 0) {
          pushIssue(
            currentNode,
            'missing-child-reference',
            missingChildReferences === 1 ? 'Missing child reference' : missingChildReferences + ' missing child references',
            'Missing collections: ' + missingChildReferenceDetails.join('; ')
          );
        }
        if (mismatchedChildLinks > 0) {
          pushIssue(
            currentNode,
            'child-parent-mismatch',
            mismatchedChildLinks === 1 ? 'Child mismatch' : mismatchedChildLinks + ' child mismatches',
            mismatchedChildLinkDetails.join('; ')
          );
        }

        if (currentNode.childHandles.length > 0) {
          var derivedChildrenMissingFromLinks = 0;
          var missingDerivedChildren = [];
          for (var derivedIndex = 0; derivedIndex < currentNode.derivedChildren.length; derivedIndex += 1) {
            if (currentNode.childHandles.indexOf(currentNode.derivedChildren[derivedIndex]) === -1) {
              derivedChildrenMissingFromLinks += 1;
              missingDerivedChildren.push(describeHandle(model, currentNode.derivedChildren[derivedIndex]));
            }
          }
          if (derivedChildrenMissingFromLinks > 0) {
            pushIssue(
              currentNode,
              'derived-child-missing-from-links',
              derivedChildrenMissingFromLinks === 1 ? 'Derived child missing from child links' : derivedChildrenMissingFromLinks + ' derived children missing from child links',
              'Missing from child links: ' + missingDerivedChildren.join(', ')
            );
          }
        }
      }

      for (index = 0; index < model.relatedHandles.length; index += 1) {
        var lineage = [];
        var visited = {};
        var handle = model.relatedHandles[index];
        var walker = handle;
        var rootHandle = '';

        while (walker && model.byHandle[walker]) {
          if (visited[walker] !== undefined) {
            for (var cycleIndex = visited[walker]; cycleIndex < lineage.length; cycleIndex += 1) {
              var cycleHandle = lineage[cycleIndex];
              model.byHandle[cycleHandle].cycle = true;
              pushIssue(model.byHandle[cycleHandle], 'cycle-detected', 'Cycle detected');
            }
            break;
          }

          visited[walker] = lineage.length;
          lineage.push(walker);

          var walkerNode = model.byHandle[walker];
          if (!walkerNode.parentHandle || !model.byHandle[walkerNode.parentHandle]) {
            rootHandle = walker;
            break;
          }

          walker = walkerNode.parentHandle;
        }

        model.byHandle[handle].rootHandle = rootHandle;
        model.byHandle[handle].depth = lineage.length > 0 ? lineage.length - 1 : 0;
      }

      for (index = 0; index < model.relatedHandles.length; index += 1) {
        currentNode = model.byHandle[model.relatedHandles[index]];
        if (currentNode.topParentHandle && currentNode.rootHandle && currentNode.topParentHandle !== currentNode.rootHandle) {
          pushIssue(
            currentNode,
            'top-parent-mismatch',
            'Top parent mismatch',
            'Stored top parent: ' + describeHandle(model, currentNode.topParentHandle) + '; derived top parent: ' + describeHandle(model, currentNode.rootHandle)
          );
        }
      }

      for (index = 0; index < model.relatedHandles.length; index += 1) {
        currentNode = model.byHandle[model.relatedHandles[index]];
        var validParent = currentNode.parentHandle && model.byHandle[currentNode.parentHandle] && model.byHandle[currentNode.parentHandle].related;
        if (!validParent) model.roots.push(currentNode.handle);
      }

      if (model.roots.length === 0) model.roots = model.relatedHandles.slice(0);
      model.roots.sort(function (leftHandle, rightHandle) {
        return compareHandles(model, leftHandle, rightHandle);
      });

      model.stats.relatedCollections = model.relatedHandles.length;
      model.stats.rootBranches = model.roots.length;

      for (index = 0; index < model.relatedHandles.length; index += 1) {
        currentNode = model.byHandle[model.relatedHandles[index]];
        if (!currentNode.imageUrl) model.stats.missingImages += 1;
        if (currentNode.issues.length > 0) model.stats.issueNodes += 1;
      }

      for (index = 0; index < ISSUE_FILTERS.length; index += 1) {
        model.stats.issueCounts[ISSUE_FILTERS[index].key] = 0;
      }

      for (index = 0; index < model.relatedHandles.length; index += 1) {
        currentNode = model.byHandle[model.relatedHandles[index]];
        for (var filterIndex = 0; filterIndex < ISSUE_FILTERS.length; filterIndex += 1) {
          if (nodeMatchesIssueFilter(currentNode, ISSUE_FILTERS[filterIndex].key)) {
            model.stats.issueCounts[ISSUE_FILTERS[filterIndex].key] += 1;
          }
        }
      }

      return model;
    }

    function createStatCard(label, value, copy) {
      return '' +
        '<div class="collection-relationship-tree__stat">' +
          '<span class="collection-relationship-tree__stat-label">' + escapeHtml(label) + '</span>' +
          '<span class="collection-relationship-tree__stat-value">' + escapeHtml(value) + '</span>' +
          '<span class="collection-relationship-tree__stat-copy">' + escapeHtml(copy) + '</span>' +
        '</div>';
    }

    function describeHandle(model, handle) {
      var describedNode = model.byHandle[handle];
      if (describedNode && describedNode.title) {
        return describedNode.title + ' (' + handle + ')';
      }
      return handle;
    }

    function matchesNode(node, query, issueFilterKey) {
      if (!nodeMatchesIssueFilter(node, issueFilterKey)) return false;
      if (!query) return true;
      var haystack = (node.title + ' ' + node.handle).toLowerCase();
      return haystack.indexOf(query) !== -1;
    }

    function renderLegend(root, state) {
      var legendElement = root.querySelector('[data-collection-tree-legend]');
      if (!legendElement || !state.model) return;

      var legendHtml = '';

      for (var index = 0; index < ISSUE_FILTERS.length; index += 1) {
        var filter = ISSUE_FILTERS[index];
        var count = state.model.stats.issueCounts[filter.key] || 0;
        var isActive = state.issueFilter === filter.key;
        legendHtml += '' +
          '<button type="button" class="collection-relationship-tree__legend-chip' + (isActive ? ' is-active' : '') + '" data-collection-tree-issue-filter="' + escapeHtml(filter.key) + '" title="' + escapeHtml(filter.tooltip) + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">' +
            escapeHtml(filter.label + ' (' + count + ')') +
          '</button>';
      }

      legendElement.innerHTML = legendHtml;
    }

    function renderIssueBadges(node) {
      if (!node.issues.length) return '';
      var html = '<div class="collection-relationship-tree__badge-list">';
      for (var issueIndex = 0; issueIndex < node.issues.length; issueIndex += 1) {
        html += '<div class="collection-relationship-tree__badge-group">';
        html += '<span class="collection-relationship-tree__badge is-issue">' + escapeHtml(node.issues[issueIndex].label) + '</span>';
        if (node.issues[issueIndex].detail) {
          html += '<p class="collection-relationship-tree__issue-detail">' + escapeHtml(node.issues[issueIndex].detail) + '</p>';
        }
        html += '</div>';
      }
      html += '</div>';
      return html;
    }

    function renderCycleStub(model, handle) {
      var node = model.byHandle[handle];
      var title = node ? node.title : handle;
      return '' +
        '<li class="collection-relationship-tree__node-shell">' +
          '<div class="collection-relationship-tree__tree-node">' +
            '<div class="collection-relationship-tree__cycle-card">' +
              '<div class="collection-relationship-tree__meta">' +
                '<div class="collection-relationship-tree__meta-top">' +
                  '<span class="collection-relationship-tree__tag">Cycle</span>' +
                '</div>' +
                '<p class="collection-relationship-tree__title">Loop back to ' + escapeHtml(title) + '</p>' +
                '<p class="collection-relationship-tree__handle">' + escapeHtml(handle) + '</p>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>';
    }

    function countVisibleNodes(model, handle, query, issueFilterKey, lineage, expansionMode, depth) {
      var node = model.byHandle[handle];
      if (!node || !node.related) return 0;

      var branchLineage = lineage.slice(0);
      branchLineage.push(handle);

      var selfMatches = matchesNode(node, query, issueFilterKey);
      var showChildren = !!query || expansionMode !== 'none';
      var total = selfMatches ? 1 : 0;
      var childContribution = 0;

      for (var childIndex = 0; childIndex < node.derivedChildren.length; childIndex += 1) {
        var childHandle = node.derivedChildren[childIndex];
        if (branchLineage.indexOf(childHandle) !== -1) {
          if (!query || matchesNode(model.byHandle[childHandle] || { title: childHandle, handle: childHandle, issueCodes: {} }, query, issueFilterKey)) {
            childContribution += 1;
          }
          continue;
        }

        childContribution += countVisibleNodes(model, childHandle, query, issueFilterKey, branchLineage, expansionMode, depth + 1);
      }

      if (childContribution > 0) total += childContribution;
      if (!selfMatches && childContribution === 0) return 0;
      if (!showChildren && !selfMatches) return 0;
      if (!showChildren) return total > 0 ? 1 : 0;
      return total;
    }

    function renderNodeCard(node, depth, visibleChildCount, childrenExist) {
      var mediaHtml = node.imageUrl
        ? '<img class="collection-relationship-tree__image" src="' + escapeHtml(node.imageUrl) + '" alt="' + escapeHtml(node.imageAlt || node.title) + '" loading="lazy">'
        : '<div class="collection-relationship-tree__image-placeholder">No image</div>';

      var metaTags = '' +
        '<div class="collection-relationship-tree__meta-top">' +
          '<span class="collection-relationship-tree__tag">' + escapeHtml(depth === 0 ? 'Root' : 'Depth ' + depth) + '</span>' +
          '<span class="collection-relationship-tree__tag">' + escapeHtml(visibleChildCount + ' visible descendants') + '</span>' +
        '</div>';

      if (node.childHandles.length > 0) {
        metaTags = metaTags.replace('</div>', '<span class="collection-relationship-tree__tag">' + escapeHtml(node.childHandles.length + ' child links') + '</span></div>');
      }

      return '' +
        '<article class="collection-relationship-tree__node-card">' +
          '<div class="collection-relationship-tree__node-card-top">' +
            mediaHtml +
            '<div class="collection-relationship-tree__meta">' +
              metaTags +
              '<p class="collection-relationship-tree__title">' + escapeHtml(node.title) + '</p>' +
              '<p class="collection-relationship-tree__handle">' + escapeHtml(node.handle) + '</p>' +
            '</div>' +
          '</div>' +
          '<div class="collection-relationship-tree__node-card-body">' +
            renderIssueBadges(node) +
            '<div class="collection-relationship-tree__actions">' +
              '<a class="collection-relationship-tree__action" href="' + escapeHtml(node.url) + '" target="_blank" rel="noopener">View storefront</a>' +
              '<a class="collection-relationship-tree__action" href="' + escapeHtml(node.adminUrl) + '" target="_blank" rel="noopener">Edit in admin</a>' +
            '</div>' +
          '</div>' +
        '</article>' +
        (childrenExist ? '<span class="collection-relationship-tree__summary-toggle">' + escapeHtml(visibleChildCount + ' branches') + '</span>' : '');
    }

    function renderNode(model, handle, query, issueFilterKey, depth, lineage, expansionMode) {
      var node = model.byHandle[handle];
      if (!node || !node.related) return { include: false, html: '' };

      var branchLineage = lineage.slice(0);
      branchLineage.push(handle);

      var selfMatches = matchesNode(node, query, issueFilterKey);
      var include = selfMatches;
      var childrenHtml = '';
      var visibleChildCount = 0;
      var showChildren = !!query || expansionMode !== 'none';

      for (var childIndex = 0; childIndex < node.derivedChildren.length; childIndex += 1) {
        var childHandle = node.derivedChildren[childIndex];
        if (branchLineage.indexOf(childHandle) !== -1) {
          if (!query || matchesNode(model.byHandle[childHandle] || { title: childHandle, handle: childHandle, issueCodes: {} }, query, issueFilterKey)) {
            childrenHtml += renderCycleStub(model, childHandle);
            include = true;
            visibleChildCount += 1;
          }
          continue;
        }

        var renderedChildCount = countVisibleNodes(model, childHandle, query, issueFilterKey, branchLineage, expansionMode, depth + 1);
        if (renderedChildCount > 0) {
          include = true;
          visibleChildCount += renderedChildCount;
          if (showChildren) {
            var renderedChild = renderNode(model, childHandle, query, issueFilterKey, depth + 1, branchLineage, expansionMode);
            if (renderedChild.include) {
              childrenHtml += renderedChild.html;
            }
          }
        }
      }

      if (!include) return { include: false, html: '' };

      var cardHtml = renderNodeCard(node, depth, visibleChildCount, !!childrenHtml);

      var html = '' +
        '<li class="collection-relationship-tree__node-shell">' +
          '<div class="collection-relationship-tree__tree-node">' +
            cardHtml;

      if (childrenHtml && showChildren) {
        html += '' +
            '<div class="collection-relationship-tree__node-children">' +
              '<ul class="collection-relationship-tree__node-children-list">' + childrenHtml + '</ul>' +
            '</div>';
      }

      html += '' +
          '</div>' +
        '</li>';

      return {
        include: true,
        html: html
      };
    }

    function createBoard(rootHandle, rootTitle, renderedRootHtml, rootNodeCount, zoomValue) {
      return '' +
        '<section class="collection-relationship-tree__board" data-tree-board data-root-handle="' + escapeHtml(rootHandle) + '" style="--board-zoom:' + escapeHtml(zoomValue) + ';">' +
          '<div class="collection-relationship-tree__board-header">' +
            '<div>' +
              '<h2 class="collection-relationship-tree__board-title">' + escapeHtml(rootTitle) + '</h2>' +
              '<p class="collection-relationship-tree__board-copy">' + escapeHtml(rootNodeCount + ' visible nodes in this branch') + '</p>' +
            '</div>' +
            '<div class="collection-relationship-tree__board-actions">' +
              '<span class="collection-relationship-tree__zoom-label">Zoom</span>' +
              '<button type="button" class="collection-relationship-tree__zoom-button" data-tree-zoom-out>-</button>' +
              '<span class="collection-relationship-tree__zoom-value" data-tree-zoom-value>' + escapeHtml(Math.round(zoomValue * 100) + '%') + '</span>' +
              '<button type="button" class="collection-relationship-tree__zoom-button" data-tree-zoom-in>+</button>' +
              '<button type="button" class="collection-relationship-tree__zoom-button" data-tree-zoom-reset>100%</button>' +
            '</div>' +
          '</div>' +
          '<div class="collection-relationship-tree__viewport" data-tree-viewport>' +
            '<div class="collection-relationship-tree__canvas" data-tree-canvas>' +
              '<div class="collection-relationship-tree__root-shell"><ul class="collection-relationship-tree__tree-list">' + renderedRootHtml + '</ul></div>' +
            '</div>' +
          '</div>' +
        '</section>';
    }

    function centerViewport(viewport) {
      if (!viewport) return;
      viewport.scrollLeft = Math.max(0, Math.round((viewport.scrollWidth - viewport.clientWidth) / 2));
    }

    function setCanvasZoom(canvas, zoomValue) {
      if (!canvas) return;

      if ('zoom' in canvas.style) {
        canvas.style.zoom = String(zoomValue);
        canvas.style.transform = '';
      } else {
        canvas.style.zoom = '';
        canvas.style.transform = 'scale(' + String(zoomValue) + ')';
      }
    }

    function applyBoardZoom(board, state, boardKey, nextZoom, options) {
      if (!board) return;

      var normalizedZoom = Math.max(0.4, Math.min(2.5, Number(nextZoom) || 1));
      var viewport = board.querySelector('[data-tree-viewport]');
      var canvas = board.querySelector('[data-tree-canvas]');
      var zoomValueElement = board.querySelector('[data-tree-zoom-value]');
      var shouldCenter = !options || options.center !== false;
      var shouldPersist = !options || options.persist !== false;

      if (shouldPersist) {
        state.boardZooms[boardKey] = Number(normalizedZoom.toFixed(2));
      }

      board.style.setProperty('--board-zoom', String(normalizedZoom));
      setCanvasZoom(canvas, normalizedZoom);

      if (zoomValueElement) {
        zoomValueElement.textContent = Math.round(normalizedZoom * 100) + '%';
      }

      if (viewport && shouldCenter) {
        window.requestAnimationFrame(function () {
          centerViewport(viewport);
        });
      }
    }

    function syncRenderedBoards(root, state) {
      var boards = root.querySelectorAll('[data-tree-board]');
      for (var boardIndex = 0; boardIndex < boards.length; boardIndex += 1) {
        var board = boards[boardIndex];
        var boardKey = board.getAttribute('data-root-handle');
        applyBoardZoom(board, state, boardKey, state.boardZooms[boardKey] || 1, { center: true, persist: false });
      }
    }

    function renderTree(root, state) {
      if (!state.model) return;

      var statsElement = root.querySelector('[data-collection-tree-stats]');
      var resultsElement = root.querySelector('[data-collection-tree-results]');
      var query = normalizeString(state.query).toLowerCase();
      var issueFilterKey = normalizeString(state.issueFilter);

      var statsHtml = '';
      statsHtml += createStatCard('Scanned', state.model.stats.scannedCollections, 'Smart collections loaded from GCF');
      statsHtml += createStatCard('Related', state.model.stats.relatedCollections, 'Smart collections with parent or child links');
      statsHtml += createStatCard('Roots', state.model.stats.rootBranches, 'Top-level branches in the tree');
      statsHtml += createStatCard('Images missing', state.model.stats.missingImages, 'Collections without a collection image');
      statsHtml += createStatCard('Issue nodes', state.model.stats.issueNodes, 'Collections with hierarchy mismatches');
      statsElement.innerHTML = statsHtml;
      renderLegend(root, state);

      if (!state.model.relatedHandles.length) {
        resultsElement.innerHTML =
          '<div class="collection-relationship-tree__empty">' +
            '<p class="collection-relationship-tree__title">No linked smart collections found.</p>' +
            '<p class="collection-relationship-tree__intro">Only smart collections participating in a parent/child relationship are shown here.</p>' +
          '</div>';
        return;
      }

      var renderedRoots = 0;
      var treeHtml = '';

      for (var rootIndex = 0; rootIndex < state.model.roots.length; rootIndex += 1) {
        var rootHandle = state.model.roots[rootIndex];
        var renderedRoot = renderNode(state.model, rootHandle, query, issueFilterKey, 0, [], state.expansionMode);
        if (!renderedRoot.include) continue;
        renderedRoots += 1;
        var rootNodeCount = countVisibleNodes(state.model, rootHandle, query, issueFilterKey, [], state.expansionMode, 0);
        var rootNode = state.model.byHandle[rootHandle];
        var boardTitle = rootNode && rootNode.title ? rootNode.title : rootHandle;
        var zoomValue = state.boardZooms[rootHandle] || 1;
        treeHtml += createBoard(rootHandle, boardTitle, renderedRoot.html, rootNodeCount, zoomValue);
      }

      if (renderedRoots === 0) {
        resultsElement.innerHTML =
          '<div class="collection-relationship-tree__empty">' +
            '<p class="collection-relationship-tree__title">No matching branches.</p>' +
            '<p class="collection-relationship-tree__intro">Try a different search term.</p>' +
          '</div>';
        return;
      }

      resultsElement.innerHTML = treeHtml;
      window.requestAnimationFrame(function () {
        syncRenderedBoards(root, state);
      });
    }

    function setStatus(root, message, isError) {
      var statusElement = root.querySelector('[data-collection-tree-status]');
      if (!statusElement) return;
      statusElement.textContent = message;
      if (isError) statusElement.classList.add('is-error');
      else statusElement.classList.remove('is-error');
    }

    function updateStatusSummary(root, state) {
      if (!state.model) return;
      var query = normalizeString(state.query);
      var issueFilterMeta = getIssueFilterMeta(state.issueFilter);
      var baseMessage =
        'Scanned ' +
        state.model.stats.scannedCollections +
        ' smart collections. Showing ' +
        state.model.stats.relatedCollections +
        ' smart collections that are part of a relationship tree.';
      if (query) baseMessage += ' Search filter: "' + query + '".';
      if (issueFilterMeta) baseMessage += ' Issue filter: "' + issueFilterMeta.label + '".';
      setStatus(root, baseMessage, false);
    }

    function bindEvents(root, state) {
      var searchInput = root.querySelector('[data-collection-tree-search]');
      var expandAllButton = root.querySelector('[data-collection-tree-expand-all]');
      var collapseAllButton = root.querySelector('[data-collection-tree-collapse-all]');
      var resetButton = root.querySelector('[data-collection-tree-reset]');

      if (searchInput) {
        searchInput.addEventListener('input', function (event) {
          state.query = event.target.value || '';
          renderTree(root, state);
          updateStatusSummary(root, state);
        });
      }

      if (expandAllButton) {
        expandAllButton.addEventListener('click', function () {
          state.expansionMode = 'all';
          renderTree(root, state);
          updateStatusSummary(root, state);
        });
      }

      if (collapseAllButton) {
        collapseAllButton.addEventListener('click', function () {
          state.expansionMode = 'none';
          renderTree(root, state);
          updateStatusSummary(root, state);
        });
      }

      if (resetButton) {
        resetButton.addEventListener('click', function () {
          state.query = '';
          state.issueFilter = '';
          state.expansionMode = 'default';
          if (searchInput) searchInput.value = '';
          renderTree(root, state);
          updateStatusSummary(root, state);
        });
      }

      if (root.dataset.collectionTreeLegendBound !== 'true') {
        root.addEventListener('click', function (event) {
          var filterButton = event.target.closest('[data-collection-tree-issue-filter]');
          if (!filterButton) return;

          var filterKey = filterButton.getAttribute('data-collection-tree-issue-filter') || '';
          state.issueFilter = state.issueFilter === filterKey ? '' : filterKey;
          renderTree(root, state);
          updateStatusSummary(root, state);
        });
        root.dataset.collectionTreeLegendBound = 'true';
      }

      if (root.dataset.collectionTreeZoomBound !== 'true') {
        root.addEventListener('click', function (event) {
          var zoomButton = event.target.closest('[data-tree-zoom-in], [data-tree-zoom-out], [data-tree-zoom-reset]');
          if (!zoomButton) return;

          var board = zoomButton.closest('[data-tree-board]');
          if (!board) return;

          var boardKey = board.getAttribute('data-root-handle');
          var currentZoom = state.boardZooms[boardKey] || 1;
          var nextZoom = currentZoom;

          if (zoomButton.hasAttribute('data-tree-zoom-in')) nextZoom = Math.min(1.8, currentZoom + 0.15);
          if (zoomButton.hasAttribute('data-tree-zoom-out')) nextZoom = Math.max(0.45, currentZoom - 0.15);
          if (zoomButton.hasAttribute('data-tree-zoom-reset')) nextZoom = 1;

          applyBoardZoom(board, state, boardKey, nextZoom);
        });
        root.dataset.collectionTreeZoomBound = 'true';
      }

      if (root.dataset.collectionTreeWheelZoomBound !== 'true') {
        root.addEventListener('wheel', function (event) {
          var viewport = event.target.closest('[data-tree-viewport]');
          if (!viewport || !event.ctrlKey) return;

          event.preventDefault();

          var board = viewport.closest('[data-tree-board]');
          if (!board) return;

          var boardKey = board.getAttribute('data-root-handle');
          var currentZoom = state.boardZooms[boardKey] || 1;
          var delta = event.deltaY < 0 ? 0.12 : -0.12;
          applyBoardZoom(board, state, boardKey, currentZoom + delta);
        }, { passive: false });
        root.dataset.collectionTreeWheelZoomBound = 'true';
      }

      if (root.dataset.collectionTreePanBound !== 'true') {
        var activeViewport = null;
        var startX = 0;
        var startY = 0;
        var startLeft = 0;
        var startTop = 0;

        root.addEventListener('pointerdown', function (event) {
          var viewport = event.target.closest('[data-tree-viewport]');
          if (!viewport) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('a, button')) return;

          activeViewport = viewport;
          startX = event.clientX;
          startY = event.clientY;
          startLeft = viewport.scrollLeft;
          startTop = viewport.scrollTop;

          viewport.classList.add('is-dragging');
          if (viewport.setPointerCapture) viewport.setPointerCapture(event.pointerId);
        });

        root.addEventListener('pointermove', function (event) {
          if (!activeViewport) return;
          event.preventDefault();
          activeViewport.scrollLeft = startLeft - (event.clientX - startX);
          activeViewport.scrollTop = startTop - (event.clientY - startY);
        });

        function releaseViewportDrag(event) {
          if (!activeViewport) return;
          if (activeViewport.releasePointerCapture) {
            try {
              activeViewport.releasePointerCapture(event.pointerId);
            } catch (error) {
            }
          }
          activeViewport.classList.remove('is-dragging');
          activeViewport = null;
        }

        root.addEventListener('pointerup', releaseViewportDrag);
        root.addEventListener('pointercancel', releaseViewportDrag);
        root.dataset.collectionTreePanBound = 'true';
      }
    }

    function fetchCollections(endpointUrl) {
      return fetch(endpointUrl, {
        method: 'GET',
        credentials: 'omit'
      }).then(function (response) {
        if (!response.ok) {
          return response.text().then(function (bodyText) {
            var message = 'Endpoint request failed with status ' + response.status;

            if (bodyText) {
              try {
                var parsedBody = JSON.parse(bodyText);
                if (parsedBody && parsedBody.message) {
                  message += ': ' + parsedBody.message;
                } else {
                  message += ': ' + bodyText;
                }
              } catch (error) {
                message += ': ' + bodyText;
              }
            }

            throw new Error(message);
          });
        }
        return response.json();
      });
    }

    function initCollectionRelationshipTree(root) {
      if (!root || root.dataset.collectionTreeReady === 'true') return;

      var config = parseConfig(root);
      if (!config || !config.endpointUrl) return;

      var state = {
        query: '',
        issueFilter: '',
        expansionMode: 'default',
        model: null,
        boardZooms: {}
      };

      bindEvents(root, state);
      setStatus(root, 'Loading smart collection relationship data.', false);

      fetchCollections(config.endpointUrl)
        .then(function (payload) {
          var collections = payload && payload.collections ? payload.collections : [];
          state.model = buildModel(collections);
          renderTree(root, state);
          updateStatusSummary(root, state);
          root.dataset.collectionTreeReady = 'true';
        })
        .catch(function (error) {
          setStatus(root, 'Failed to load collection relationship data from the endpoint. ' + error.message, true);
        });
    }

    function initCollectionRelationshipTrees(container) {
      var context = container || document;
      var trees = context.querySelectorAll('[data-collection-tree-root]');
      for (var index = 0; index < trees.length; index += 1) {
        initCollectionRelationshipTree(trees[index]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCollectionRelationshipTrees(document);
      });
    } else {
      initCollectionRelationshipTrees(document);
    }

    if (!window.__collectionRelationshipTreeSectionLoadBound) {
      window.__collectionRelationshipTreeSectionLoadBound = true;
      document.addEventListener('shopify:section:load', function (event) {
        initCollectionRelationshipTrees(event.target);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-deals-size-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Carries over width, brand, and price, but allows block's specific size to dictate the URL.
    function isSizeParamKey(key) {
      if (!key) return false;
      var normalized = String(key).toLowerCase();
      
      if (normalized === 'page_size') return false;
      if (normalized.indexOf('resize') !== -1) return false;

      // Parameters to persist across clicks
      if (normalized.indexOf('size') !== -1) return true;
      if (normalized.indexOf('width') !== -1) return true;
      if (normalized.indexOf('brand') !== -1) return true;
      if (normalized.indexOf('price') !== -1) return true;

      return false;
    }

    function getCurrentSizeParams() {
      var currentSizeParams = [];
      if (!window.URLSearchParams || !window.location) return currentSizeParams;

      function pushUniqueParam(key, value) {
        for (var i = 0; i < currentSizeParams.length; i += 1) {
          if (currentSizeParams[i].key === key && currentSizeParams[i].value === value) {
            return;
          }
        }
        currentSizeParams.push({ key: key, value: value });
      }

      var currentParams = new URLSearchParams(window.location.search || '');
      currentParams.forEach(function (value, key) {
        if (isSizeParamKey(key)) {
          pushUniqueParam(key, value);
        }
      });

      var filterInputs = document.querySelectorAll('input[name], select[name]');
      for (var inputIndex = 0; inputIndex < filterInputs.length; inputIndex += 1) {
        var input = filterInputs[inputIndex];
        if (!input) continue;

        var inputName = input.name || '';
        if (!isSizeParamKey(inputName)) continue;

        var tagName = (input.tagName || '').toLowerCase();
        if (tagName === 'input') {
          var type = (input.type || '').toLowerCase();
          if (type !== 'checkbox' && type !== 'radio') continue;
          if (!input.checked) continue;
          pushUniqueParam(inputName, input.value);
          continue;
        }

        if (tagName === 'select') {
          if (input.multiple && input.options) {
            for (var optionIndex = 0; optionIndex < input.options.length; optionIndex += 1) {
              var option = input.options[optionIndex];
              if (option && option.selected && option.value !== '') {
                pushUniqueParam(inputName, option.value);
              }
            }
          } else {
            if (input.value !== '') {
              pushUniqueParam(inputName, input.value);
            }
          }
        }
      }

      return currentSizeParams;
    }

    function toRelativeHref(urlObject) {
      return urlObject.pathname + urlObject.search + urlObject.hash;
    }

    function applyCurrentSizeParamsToLink(link) {
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href) return;
      if (href.indexOf('javascript:') === 0 || href.charAt(0) === '#') return;

      var linkUrl;
      try {
        linkUrl = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      var currentSizeParams = getCurrentSizeParams();
      
      for (var sizeIndex = 0; sizeIndex < currentSizeParams.length; sizeIndex += 1) {
        var pKey = currentSizeParams[sizeIndex].key;
        var pVal = currentSizeParams[sizeIndex].value;

        // If this is a size parameter and the button's link ALREADY has a size parameter, skip it.
        // This ensures the link's hardcoded size wins over the window's current size.
        if (pKey.indexOf('size') !== -1 && linkUrl.search.indexOf('size') !== -1) {
          continue;
        }

        // Only append if the key isn't already present on the block's link
        if (!linkUrl.searchParams.has(pKey)) {
          linkUrl.searchParams.append(pKey, pVal);
        }
      }

      link.setAttribute('href', toRelativeHref(linkUrl));
    }

    function persistSizesParamsOnChildLinks(section) {
      if (!section) return;
      if (!window.URLSearchParams || !window.URL) return;

      var links = section.querySelectorAll('[data-size-grid-card]');
      for (var linkIndex = 0; linkIndex < links.length; linkIndex += 1) {
        var link = links[linkIndex];
        
        applyCurrentSizeParamsToLink(link);

        if (link.getAttribute('data-size-grid-listener') !== 'true') {
          link.addEventListener('click', function (event) {
            applyCurrentSizeParamsToLink(event.currentTarget);
          });
          link.setAttribute('data-size-grid-listener', 'true');
        }
      }
    }

    function syncCollectionChildGridLinks(root) {
      var context = root || document;
      var sections = context.querySelectorAll('[data-size-grid-section]');
      for (var sectionIndex = 0; sectionIndex < sections.length; sectionIndex += 1) {
        persistSizesParamsOnChildLinks(sections[sectionIndex]);
      }
    }

    function bindCollectionChildGridSizeSyncListeners() {
      if (window.__sizeGridSyncBound) return;
      window.__sizeGridSyncBound = true;

      function scheduleSync() {
        window.setTimeout(function () {
          syncCollectionChildGridLinks(document);
        }, 0);
      }

      function wrapHistoryMethod(methodName) {
        if (!window.history || typeof window.history[methodName] !== 'function') return;

        var originalMethod = window.history[methodName];
        if (originalMethod.__sizeGridWrapped) return;

        var wrappedMethod = function () {
          var result = originalMethod.apply(window.history, arguments);
          scheduleSync();
          return result;
        };

        wrappedMethod.__sizeGridWrapped = true;
        window.history[methodName] = wrappedMethod;
      }

      wrapHistoryMethod('pushState');
      wrapHistoryMethod('replaceState');

      window.addEventListener('popstate', scheduleSync);
      window.addEventListener('hashchange', scheduleSync);

      document.addEventListener('change', function (event) {
        var target = event.target;
        if (!target) return;
        var targetName = target.name || '';
        var targetId = target.id || '';
        if (isSizeParamKey(targetName) || isSizeParamKey(targetId)) {
          scheduleSync();
          window.setTimeout(scheduleSync, 150);
        }
      }, true);
    }

    function initChildGridSection(section) {
      if (!section || section.dataset.sizeGridReady == 'true') return;

      persistSizesParamsOnChildLinks(section);

      var cardsContainer = section.querySelector('[data-size-grid-cards]');
      var button = section.querySelector('[data-size-grid-load-more]');

      if (!cardsContainer || !button) {
        if (section) section.dataset.sizeGridReady = 'true';
        return;
      }

      var isExpanded = false;
      var showText = button.textContent.trim();
      var hideText = button.getAttribute('data-hide-text') || 'Hide';

      button.addEventListener('click', function () {
        isExpanded = !isExpanded;

        if (isExpanded) {
          cardsContainer.classList.add('is-expanded');
          button.textContent = hideText;
        } else {
          cardsContainer.classList.remove('is-expanded');
          button.textContent = showText;
          section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });

      section.dataset.sizeGridReady = 'true';
    }

    function initCollectionChildGrids(root) {
      var context = root || document;
      var sections = context.querySelectorAll('[data-size-grid-section]');
      for (var index = 0; index < sections.length; index += 1) {
        initChildGridSection(sections[index]);
      }
      syncCollectionChildGridLinks(context);
    }

    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCollectionChildGrids(document);
      });
    } else {
      initCollectionChildGrids(document);
    }

    if (!window.__sizeGridSectionLoadBound) {
      window.__sizeGridSectionLoadBound = true;
      document.addEventListener('shopify:section:load', function (event) {
        initCollectionChildGrids(event.target);
      });
    }

    bindCollectionChildGridSizeSyncListeners();
  })();

  } catch(e) { console.error(e); }
})();
})();
